import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectsComponent } from 'src/app/sections/projects/projects.component';
import { RouterModule } from '@angular/router';
import { AboutComponent } from 'src/app/sections/about/about.component';
import { ContactComponent } from 'src/app/sections/contact/contact.component';
import { HeroComponent } from 'src/app/sections/hero/hero.component';
import { ServicesComponent } from 'src/app/sections/services/services.component';
import { TechnologiesComponent } from 'src/app/sections/technologies/technologies.component';
import { TestimonialsComponent } from 'src/app/sections/testimonials/testimonials.component';
import { BlogTeaserComponent } from 'src/app/sections/blog-teaser/blog-teaser.component';
import { AiChatComponent } from '../ai-chat/ai-chat.component';
import { AvaProductComponent } from 'src/app/sections/ava-product/ava-product.component';

@Component({
  selector: 'app-home',
  imports: [
    CommonModule,     
    RouterModule,
    HeroComponent,
    AboutComponent,
    ServicesComponent,
    ProjectsComponent,
    TestimonialsComponent,
    TechnologiesComponent,
    ContactComponent,
    BlogTeaserComponent,
    AiChatComponent,
    AvaProductComponent,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {}
